export const toLowerSnakeCase = string => {
  return string.toLowerCase().replace(/\s/g, '_')
}

export const stringToSpacedPascal = string => {
  return string.toLowerCase().split(' ').map((word) => {
    return word.substring(0, 1).toUpperCase() + word.substring(1)
  }).join(' ')
}
